module.exports = __webpack_public_path__ + "img/03.25374a50.jpg";